var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-1 h-1 mr-2 bg-white rounded-full flex-shrink-0 transform translate-y-[8px]"})
}
var staticRenderFns = []

export { render, staticRenderFns }